export default [
	{
		path: '/my/',
		component: (resolve) => require(['@/components/my/Index'], resolve),
		meta: {
			title: '个人中心',
			loginIn: true
		}
	},
	{
		path: '/my/study-center/course',
		component: (resolve) => require(['@/components/my/studyCenter/Course'], resolve),
		meta: {
			title: '我的课程',
			loginIn: true
		}
	},
	{
		path: '/my/study-center/report',
		component: (resolve) => require(['@/components/my/studyCenter/Report'], resolve),
		meta: {
			title: '学习报告',
			loginIn: true
		}
	},
	{
		path: '/my/study-center/exam',
		component: (resolve) => require(['@/components/my/studyCenter/Exam'], resolve),
		meta: {
			title: '练习记录',
			loginIn: true
		}
	},
	{
		path: '/my/study-center/appointment',
		component: (resolve) => require(['@/components/my/studyCenter/Appointment'], resolve),
		meta: {
			title: '预约报名',
			loginIn: true
		}
	},
	{
		path: '/my/study-center/order',
		component: (resolve) => require(['@/components/my/studyCenter/Order'], resolve),
		meta: {
			title: '我的订单',
			loginIn: true
		}
	},
    {
        path: '/my/study-center/again_order',
        component: (resolve) => require(['@/components/my/studyCenter/AgainOrder'], resolve),
        meta: {
            title: '立即支付订单',
            loginIn: true
        }
    },
	{
		path: '/my/study-center/order_comment',
		component: (resolve) => require(['@/components/my/studyCenter/OrderComment'], resolve),
		meta: {
			title: '我的订单评价',
			loginIn: true
		}
	},


	//#--------------------------MyCoupon--------------------------------
	{
		path: '/my/my-coupon',
		component: (resolve) => require(['@/components/my/MyCoupon'], resolve),
		meta: {
			title: '我的优惠券',
			loginIn: true
		}
	},

	//#--------------------------refund--------------------------------
	{
		path: '/my/refund/my-refund',
		component: (resolve) => require(['@/components/my/refund/MyRefund'], resolve),
		meta: {
			title: '售后退款',
			loginIn: true
		}
	},

	//#--------------------------comments--------------------------------
	{
		path: '/my/comments/my-comments',
		component: (resolve) => require(['@/components/my/comments/MyComments'], resolve),
		meta: {
			title: '我的评论',
			loginIn: true
		}
	},
	//#--------------------------ExChangeCode------------------------------
	{
		path: '/my/ex-change-code',
		component: (resolve) => require(['@/components/my/ExChangeCode'], resolve),
		meta: {
			title: '兑课码',
			loginIn: true
		}
	},
	//#--------------------------Proposal------------------------------
	{
		path: '/my/proposal/proposal',
		component: (resolve) => require(['@/components/my/proposal/Proposal'], resolve),
		meta: {
			title: '投诉建议',
			loginIn: true
		}
	},
	{
		path: '/my/proposal/proposal-list',
		component: (resolve) => require(['@/components/my/proposal/ProposalList'], resolve),
		meta: {
			title: '投诉建议',
			loginIn: true
		}
	},


	//#--------------------------setting--------------------------------
	{
		path: '/my/setting/binding',
		component: (resolve) => require(['@/components/my/setting/Binding'], resolve),
		name: 'binding',
		meta: {
			title: '绑定手机号',
			exclude: 'binding',
			loginIn: true
		}
	},
	{
		path: '/my/setting/binding-ver',
		component: (resolve) => require(['@/components/my/setting/BindingVer'], resolve),
		meta: {
			title: '绑定手机号',
			exclude: 'binding',
			loginIn: true
		}
	},
	{
		path: '/my/setting/index',
		component: (resolve) => require(['@/components/my/setting/Index'], resolve),
		meta: {
			title: '基本资料',
			loginIn: true
		}
	},
	{
		path: '/my/setting/user-data',
		component: (resolve) => require(['@/components/my/setting/UserData'], resolve),
		meta: {
			title: '个人资料',
			loginIn: true
		}
	},
	{
		path: '/my/setting/head-form',
		component: (resolve) => require(['@/components/my/setting/HeadForm'], resolve),
		meta: {
			title: '头像上传',
			loginIn: true
		}
	},
	{
		path: '/my/setting/change-password',
		component: (resolve) => require(['@/components/my/setting/ChangePassword'], resolve),
		meta: {
			title: '修改密码',
			loginIn: true
		}
	},

	{
		path: '/my/setting/change-phone',
		component: (resolve) => require(['@/components/my/setting/ChangePhone'], resolve),
		meta: {
			title: '修改手机号',
			loginIn: true
		}
	},

	{
		path: '/my/setting/reset-password',
		component: (resolve) => require(['@/components/my/setting/ResetPassword'], resolve),
		meta: {
			title: '密码修改',
			loginIn: true
		}
	},
	//#------------------------------address--------------------------------------
	{
		path: '/my/setting/address/index',
		component: (resolve) => require(['@/components/my/setting/address/Index'], resolve),
		meta: {
			title: '地址管理',
			loginIn: true,
			default: '/my/setting/index',
			multiple: true,
			exclude: 'pageBack'
		}
	},

	{
		path: '/my/setting/address/edit',
		component: (resolve) => require(['@/components/my/setting/address/Edit'], resolve),
		name: 'address',
		meta: {
			title: '编辑地址',
			loginIn: true,
			exclude: 'pageBack'
		}
	},

	{
		path: '/my/setting/address/modify',
		component: (resolve) => require(['@/components/my/setting/address/Modify'], resolve),
		meta: {
			title: '地址管理',
			loginIn: true,
			exclude: 'pageBack'
		}
	},

	{
		path: '/my/setting/address/new',
		component: (resolve) => require(['@/components/my/setting/address/New'], resolve),
		meta: {
			title: '添加地址',
			loginIn: true,
			exclude: 'pageBack'
		}
	},
	//#-----------------------------end-address---------------------------------
	//#-----------------------------end-setting---------------------------------

	//#-------------------------------service-----------------------------

	{
		path: '/my/service/customer-service',
		component: (resolve) => require(['@/components/my/service/CustomerService'], resolve),
		meta: {
			title: '客服中心',
			default: '/my/',
			multiple: true,
			exclude: 'pageBack',
			loginIn: true
		}
	},

	{
		path: '/my/service/make-money',
		component: (resolve) => require(['@/components/my/service/MakeMoney'], resolve),
		meta: {
			title: '我要赚钱',
			loginIn: true
		}
	},
	{
		path: '/my/service/collection',
		component: (resolve) => require(['@/components/my/service/Collection'], resolve),
		meta: {
			title: '我的收藏',
			loginIn: true
		}
	},
	{
		path: '/my/service/we-chat-card',
		component: (resolve) => require(['@/components/my/service/WeChatCard'], resolve),
		meta: {
			title: '微信名片',
			loginIn: true
		}
	},
	{
		path: '/my/service/admission-ticket/list',
		component: (resolve) => require(['@/components/my/service/admissionTicket/list'], resolve),
		meta: {
			title: '准考证列表',
			loginIn: true
		}
	},
	{
		path: '/my/service/admission-ticket/detail',
		component: (resolve) => require(['@/components/my/service/admissionTicket/detail'], resolve),
		meta: {
			title: '准考证详情',
			loginIn: true
		}
	},
	{
		path: '/my/service/results/list',
		component: (resolve) => require(['@/components/my/service/results/list'], resolve),
		meta: {
			title: '成绩列表',
			loginIn: true
		}
	},

	//#----------------------------------capital-------------------------------
	{
		path: '/my/service/capital/capital',
		component: (resolve) => require(['@/components/my/service/capital/capital'], resolve),
		meta: {
			title: '资金中心',
			loginIn: true
		}
	},
	{
		path: '/my/service/capital/capital-cash',
		component: (resolve) => require(['@/components/my/service/capital/CapitalCash'], resolve),
		meta: {
			title: '资金提现',
			loginIn: true
		}
	},
    {
        path: '/my/service/capital/cash-finish',
        component: (resolve) => require(['@/components/my/service/capital/CashFinish'], resolve),
        meta: {
            title: '资金提现完成',
            loginIn: true
        }
    },
	{
		path: '/my/service/capital/capital-det',
		component: (resolve) => require(['@/components/my/service/capital/CapitalDet'], resolve),
		meta: {
			title: '资金明细',
			loginIn: true
		}
	},
	{
		path: '/my/service/capital/cash-record',
		component: (resolve) => require(['@/components/my/service/capital/CashRecord'], resolve),
		meta: {
			title: '提现记录',
			loginIn: true
		}
	},
	{
		path: '/my/service/capital/profit-record',
		component: (resolve) => require(['@/components/my/service/capital/ProfitRecord'], resolve),
		meta: {
			title: '佣金记录',
			loginIn: true
		}
	},
	{
		path: '/my/service/capital/spend-record',
		component: (resolve) => require(['@/components/my/service/capital/SpendRecord'], resolve),
		meta: {
			title: '消费记录',
			loginIn: true
		}
	},
	//#-----------------------------end-capital---------------------------------


	//#----------------------------------extension-------------------------------
	{
		path: '/my/service/extension/activity',
		component: (resolve) => require(['@/components/my/service/extension/Activity'], resolve),
		meta: {
			title: '活动分销',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/activity-det',
		component: (resolve) => require(['@/components/my/service/extension/ActivityDet'], resolve),
		meta: {
			title: '报名列表',
		}
	},
	{
		path: '/my/service/extension/activity-my',
		component: (resolve) => require(['@/components/my/service/extension/ActivityMy'], resolve),
		meta: {
			title: '我的活动推广',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/activity-order',
		component: (resolve) => require(['@/components/my/service/extension/ActivityOrder'], resolve),
		meta: {
			title: '活动推广详情',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/article-list',
		component: (resolve) => require(['@/components/my/service/extension/ArticleList'], resolve),
		meta: {
			title: '内容分享列表',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/article-my',
		component: (resolve) => require(['@/components/my/service/extension/ArticleMy'], resolve),
		meta: {
			title: '我的分享',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/article-myList',
		component: (resolve) => require(['@/components/my/service/extension/ArticleMyList'], resolve),
		meta: {
			title: '文章推广人统计',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/extension',
		component: (resolve) => require(['@/components/my/service/extension/Extension'], resolve),
		meta: {
			title: '推广佣金',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/ranking',
		component: (resolve) => require(['@/components/my/service/extension/Ranking'], resolve),
		meta: {
			title: '推广佣金排行',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/record',
		component: (resolve) => require(['@/components/my/service/extension/Record'], resolve),
		meta: {
			title: '推广佣金',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/course-det',
		component: (resolve) => require(['@/components/my/service/extension/CourseDet'], resolve),
		meta: {
			title: '佣金明细',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/extension-course',
		component: (resolve) => require(['@/components/my/service/extension/ExtensionCourse'], resolve),
		meta: {
			title: '课程推广',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/course-ext',
		component: (resolve) => require(['@/components/my/service/extension/CourseExt'], resolve),
		meta: {
			title: '推广课程列表',
			loginIn: true
		}
	},
	{
		path: '/my/service/extension/course-order',
		component: (resolve) => require(['@/components/my/service/extension/CourseOrder'], resolve),
		meta: {
			title: '推广人订单',
			loginIn: true
		}
	},
	//#-----------------------------end-extension---------------------------------

	//#----------------------------------integral-------------------------------


	{
		path: '/my/service/integral/cap-record',
		component: (resolve) => require(['@/components/my/service/integral/CapRecord'], resolve),
		meta: {
			title: '积分中心',
			loginIn: true
		}
	},
	{
		path: '/my/service/integral/gift-details',
		component: (resolve) => require(['@/components/my/service/integral/GiftDetails'], resolve),
		meta: {
			title: '礼物详情',
			loginIn: true
		}
	},
	{
		path: '/my/service/integral/gift-record',
		component: (resolve) => require(['@/components/my/service/integral/GiftRecord'], resolve),
		meta: {
			title: '礼物兑换记录',
			loginIn: true
		}
	},
	{
		path: '/my/service/integral/integral',
		component: (resolve) => require(['@/components/my/service/integral/Integral'], resolve),
		meta: {
			title: '积分中心',
			loginIn: true
		}
	},
	{
		path: '/my/service/integral/integral-cap',
		component: (resolve) => require(['@/components/my/service/integral/IntegralCap'], resolve),
		meta: {
			title: '兑换现金',
			loginIn: true
		}
	},

	{
		path: '/my/service/integral/integral-gift',
		component: (resolve) => require(['@/components/my/service/integral/IntegralGift'], resolve),
		meta: {
			title: '积分兑换',
			loginIn: true
		}
	},

	//#-----------------------------end-integral---------------------------------

	//#----------------------------------turnTable-------------------------------
	{
		path: '/my/service/turn-table/prize-det',
		component: (resolve) => require(['@/components/my/service/turnTable/PrizeDet'], resolve),
		meta: {
			title: '奖品详情',
			loginIn: true,
			default: '/my/service/turn-table/turntable_list',
			multiple: true,
			exclude: 'pageBack'
		}
	},
	{
		path: '/my/service/turn-table/prize-rec',
		component: (resolve) => require(['@/components/my/service/turnTable/PrizeRec'], resolve),
		meta: {
			title: '抽奖记录',
			loginIn: true,
		}
	},
	{
		path: '/my/service/turn-table/turn-table',
		component: (resolve) => require(['@/components/my/service/turnTable/Turntable'], resolve),
		meta: {
			title: '抽大奖',
			loginIn: true,
			multiple: true,
			default: '/my/service/turn-table/turntable_list',
		}
	},

	{
		path: '/my/service/turn-table/turntable_list',
		component: (resolve) => require(['@/components/my/service/turnTable/TurntableList'], resolve),
		meta: {
			title: '抽奖列表',
			loginIn: true,
			default: '/my/',
			multiple: true,
		}
	},

	{
		path: '/my/service/turn-table/Turntable_service',
		component: (resolve) => require(['@/components/my/service/turnTable/TurntableService'], resolve),
		meta: {
			title: '抽奖活动客服',
			loginIn: true,
		}
	},
	//#-----------------------------end-turnTable---------------------------------
	{
		path: '/my/service/activity/active-det',
		component: (resolve) => require(['@/components/my/service/activity/ActiveDet'], resolve),
		meta: {
			title: '活动推广详情',
			loginIn: true
		}
	},
	{
		path: '/my/service/activity/active',
		component: (resolve) => require(['@/components/my/service/activity/Active'], resolve),
		meta: {
			title: '活动推广列表',
			loginIn: true
		}
	},


	//#----------------------------------invitation-------------------------------

	{
		path: '/my/invitation/invitation',
		component: (resolve) => require(['@/components/my/invitation/Invitation'], resolve),
		meta: {
			title: '团队中心',
			loginIn: true
		}
	},
	{
		path: '/my/invitation/invitation-det',
		component: (resolve) => require(['@/components/my/invitation/InvitationDet'], resolve),
		meta: {
			title: '邀请好友',
			loginIn: true
		}
	},
	{
		path: '/my/invitation/invitation-other',
		component: (resolve) => require(['@/components/my/invitation/InvitationOther'], resolve),
		meta: {
			title: '团队成员',
		}
	},
	{
		path: '/my/invitation/invitation-ranking',
		component: (resolve) => require(['@/components/my/invitation/InvitationRanking'], resolve),
		meta: {
			title: '团队排行',
			loginIn: true
		}
	},

	//#-----------------------------end-invitation---------------------------------


	//#----------------------------------activity-------------------------------


	//#-----------------------------end-service---------------------------------


]



// WEBPACK FOOTER //
// ./src/router/my.js